import React, { useState, useRef, useEffect, useContext, useCallback } from "react";

import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import TernsService from "bodycodi/cmap/app/components/cmap1010/ternsService";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";
import logo from "bodycodi/cmap/app/img/bodycodi-logo.png";

type TernServicePopProp = {
  setAllAgree: Function;
  setAgreeMarketingYn: Function;
};

type TernServicePopProp1 = {
  setAllAgreeP: Function;
  setAgreeMarketingYnP: Function;
};

function TernServicePopWrap({ setAllAgree, setAgreeMarketingYn }: TernServicePopProp) {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);

  const handleClose = useCallback(() => {
    dispatch({ type: "POP_UP_OPEN", id: "TERN_SERVICE_POP", open: { ternServicePop: false } });
  }, []);

  return (
    <CustomDialog open={state.ternServicePop} onClose={handleClose} className="ternService">
      <PopupHeader title="" onClickBack={handleClose} />
      {state.ternServicePop && (
        <TernServicePop setAllAgreeP={setAllAgree} setAgreeMarketingYnP={setAgreeMarketingYn} />
      )}
    </CustomDialog>
  );
}

function TernServicePop({ setAllAgreeP, setAgreeMarketingYnP }: TernServicePopProp1) {
  const footer = useRef<HTMLDivElement>(null);
  const [allAgree, setAllAgree] = useState(false);
  const [agreeMarketingYn, setAgreeMarketingYn] = useState(false);
  const { dispatch } = useContext(DispatchContext);

  useEffect(() => {
    const join_member_footer = footer.current;
    if (allAgree) {
      join_member_footer?.classList.add("active");
    } else {
      join_member_footer?.classList.remove("active");
    }
  }, [allAgree]);

  const openJoinPop = useCallback(() => {
    dispatch({ type: "POP_UP_OPEN", id: "JOIN_POP", open: { joinPop: true } });
  }, []);

  const clickAgree = useCallback(() => {
    if (allAgree) {
      setAllAgreeP(allAgree);
      setAgreeMarketingYnP(agreeMarketingYn);
      openJoinPop();
    }
  }, [allAgree, agreeMarketingYn]);

  return (
    <div className="popup-body">
      <div className="tern-service-header">
        <img src={logo} />
        <div className="black">회원가입</div>
      </div>
      <TernsService setAgree={setAllAgree} setAgreeMarketingYn={setAgreeMarketingYn} />
      <div className="cmap1010-btn tern-service-btn" ref={footer} onClick={clickAgree}>
        이용약관 동의
      </div>
    </div>
  );
}

export default TernServicePopWrap;
